import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from 'src/app/Shared/material.module';
import { NavbarVerticalStyle1Component } from 'src/app/layout/components/navbar/vertical/style-1/style-1.component';
import { FuseNavigationComponent } from '../../../fuse-navigation/navigation/navigation.component';

@NgModule({
  declarations: [NavbarVerticalStyle1Component],
  imports: [MatButtonModule, MatIconModule, MaterialModule, FuseNavigationComponent],
  exports: [NavbarVerticalStyle1Component],
})
export class NavbarVerticalStyle1Module {}
